module.exports = __webpack_public_path__ + "static/media/two_column_black.33d98650.svg";